export function getCart() {
  const url = `${window.Shopify.routes.root}cart.js?t=${Date.now()}`
  return fetch(url, {
    credentials: 'same-origin',
    method: 'GET'
  }).then((response) => response.json())
}

export function getCartProductMarkup() {
  let url = `${window.Shopify.routes.root}cart?t=${Date.now()}`

  url += url.includes('?') ? `&view=ajax` : `?view=ajax`

  return fetch(url, {
    credentials: 'same-origin',
    method: 'GET'
  })
    .then((response) => response.text())
    .catch((e) => console.error(e))
}

export function changeItem(key, qty) {
  return _updateCart({
    url: `${window.Shopify.routes.root}cart/change.js?t=${Date.now()}`,
    data: JSON.stringify({
      id: key,
      quantity: qty
    })
  })
}

export function updateAttribute(key, value) {
  return _updateCart({
    url: '/cart/update.js',
    data: JSON.stringify({
      attributes: {
        [key]: _attributeToString(value)
      }
    })
  })
}

export function updateNote(note) {
  return _updateCart({
    url: '/cart/update.js',
    data: JSON.stringify({
      note: _attributeToString(note)
    })
  })
}

function _updateCart(params) {
  return fetch(params.url, {
    method: 'POST',
    body: params.data,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    }
  })
    .then((response) => {
      return response.text()
    })
    .then((cart) => {
      return cart
    })
}

function _attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += ''
    if (attribute === 'undefined') {
      attribute = ''
    }
  }
  return attribute.trim()
}

export function updateCartItemVariant(selectEl) {
  const newVariantId = selectEl.value;
  const oldItemKey = selectEl.dataset.itemKey;

  const isCartPage = window.location.pathname === '/cart';

  let quantity = 1;
  const row = selectEl.closest('.cart__item');
  const qtyInput = row?.querySelector('input.js-qty__num');
  if (qtyInput) {
    const parsed = parseInt(qtyInput.value, 10);
    if (!isNaN(parsed) && parsed > 0) {
      quantity = parsed;
    }
  }

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: oldItemKey, quantity: 0 })
  })
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newVariantId, quantity })
        });
      })
      .then(() => {
        if (isCartPage) {
          location.reload();
        } else {
          // Only refresh the cart drawer content
          const cartDrawer = document.querySelector('header-cart-drawer');
          const container = cartDrawer?.querySelector('[data-products]');

          if (container) {
            return getCartProductMarkup().then((html) => {
              const temp = document.createElement('div');
              temp.innerHTML = html;
              const newContent = temp.querySelector('[data-products]');
              if (newContent) {
                container.innerHTML = newContent.innerHTML;
              }
            });
          }
        }
      })
      .then(() => {
        // Update item count in subtotal label and cart drawer title
        return fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              const itemLabel = document.querySelector('.cart__item--subtotal-label');
              if (itemLabel) {
                itemLabel.textContent = `Subtotal (${cart.item_count} Item${cart.item_count === 1 ? '' : 's'})`;
              }

              const cartHeader = document.querySelector('.cart__tools p');
              if (cartHeader) {
                const label = cartHeader.textContent.split('(')[0].trim();
                cartHeader.textContent = `${label} (${cart.item_count})`;
              }
            });
      })
      .catch((error) => console.error('Cart update failed:', error));
}